<template>
	<DialogRevamp
		class="bs-geo-redirect-dialog"
		:value="value"
		@input="emit('input', $event)"
		size="sm"
		is-hide-header-border
		@on-hide="handleHide"
	>
		<template #header>
			<div class="empty-placeholder-header"></div>
		</template>
		<template #content>
			<div class="bs-geo-redirect-dialog__content">
				<div v-if="geoRedirectData" class="bs-geo-redirect-dialog__message">
					<i
						class="bs-geo-redirect-dialog__flag"
						:class="'icon-flag-' + geoRedirectData.site + '-md'"
					></i>

					<div
						class="bs-geo-redirect-dialog__title"
						v-html="displayedTitle"
					></div>

					<div class="bs-geo-redirect-dialog__description">
						{{ displayedDescription }}
					</div>
				</div>

				<div class="bs-geo-redirect-dialog__actions">
					<BaseButton
						variant="pcs-primary"
						size="large"
						:is-full-width="true"
						@click="handleSwitch"
					>
						{{ content.button_switch }}
					</BaseButton>
					<BaseButton
						:text="content.button_stay"
						variant="secondary"
						size="large"
						:is-full-width="true"
						@click="handleStay"
					>
						{{ content.button_stay }}
					</BaseButton>
				</div>
			</div>
		</template>
	</DialogRevamp>
</template>

<script setup>
import { computed } from 'vue'
import DialogRevamp from '@/components/DialogRevamp.vue'
import BaseButton from '@/components/ui/button/BaseButton.vue'

const props = defineProps({
	value: {
		type: Boolean,
		default: false,
	},
	geoRedirectData: {
		type: Object,
		default: null,
	},
	content: {
		type: Object,
		default: null,
	},
})

const emit = defineEmits(['input', 'hide', 'switch', 'stay'])

const geoCountry = computed(() => {
	return window.BUYANDSHIP.settings.all_countries[props.geoRedirectData.site]
		.name
})

const displayedTitle = computed(() => {
	return props.content.title.replace('{geoCountry}', geoCountry.value)
})

const displayedDescription = computed(() => {
	return props.content.description.replace('{geoCountry}', geoCountry.value)
})

const handleHide = () => {
	emit('input', false)
	emit('hide')
}

const handleSwitch = () => {
	emit('switch', props.geoRedirectData)
}

const handleStay = () => {
	emit('stay')
}
</script>
